export function activitiesReducer(state, action) {
  switch (action.type) {
    case "skip_activity": {
      return {
        ...state,
        items: state.items.map((a, i) => {
          if (i === action.index) {
            return {
              ...a,
              flg_disabled: !!action.skipped,
            };
          }
          return a;
        }),
      };
    }
    case "check_activity": {
      return {
        ...state,
        items: state.items.map((a, i) => {
          if (i === action.index) {
            return {
              ...a,
              closed_at: action.checked ? new Date() : null,
              val_closed_by: action.checked ? action.closed_by : "",
            };
          }
          return a;
        }),
      };
    }
    case "edit_activity": {
      return {
        ...state,
        items: state.items.map((a, i) => {
          if (i === action.index) {
            return {
              ...a,
              val_text: action.title !== null ? action.title : a.val_text,
              val_description:
                action.description !== null
                  ? action.description
                  : a.val_description,
            };
          }
          return a;
        }),
      };
    }
    case "set_activities": {
      return {
        items: action.activities.map((a) => ({
          ...a,
          closed_at:
            typeof a.closed_at === "string"
              ? new Date(a.closed_at)
              : a.closed_at,
          created_at:
            typeof a.created_at === "string"
              ? new Date(a.created_at)
              : a.created_at,
        })),
      };
    }
    case "add_activities": {
      const initial = action.reset ? [] : state.items;
      return {
        ...state,
        items: action.activities.reduce((acc, activity) => {
          const item_orders = acc.map((a) => a.val_order || 0);
          const order = item_orders.length ? Math.max(...item_orders) + 1 : 0;
          return [
            ...acc,
            {
              id_task: null,
              id_checklist_item: null,
              val_text: "",
              val_description: "",
              closed_at: null,
              created_at: new Date(),
              val_closed_by: null,
              val_order: order,
              flg_disabled: false,
              val_creator: action.owner,
              activity_type: "custom",
              ...activity,
            },
          ];
        }, initial),
      };
    }
    case "delete_activity": {
      const item = state.items.find((a, i) => i === action.index);
      if (item.id) {
        return {
          ...state,
          items: state.items.map((a, i) => {
            if (i === action.index) {
              return {
                ...a,
                to_delete: !!action.to_delete,
              };
            }
            return a;
          }),
        };
      } else {
        return {
          items: state.items.filter((a, i) => i !== action.index),
        };
      }
    }
    default:
      throw Error("Unknown action: " + action.type);
  }
}
